import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Empty, Spin, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";
import {
  checkSignActById,
  downloadActById,
  getActById,
  signActById,
} from "entities/acts";
import { getActPdfById } from "entities/acts/api";
import { ReceivePaymentButton } from "features/card-bait";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ROUTES from "shared/routes";
import { SingDocument, ViewDocument } from "widgets/sign-document";
import styles from "./index.module.scss";

export const SingActPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { actId } = useParams();
  const [shouldPoll, setShouldPoll] = useState(false);

  const {
    data: act,
    isLoading: isLoadingAct,
    isError: isErrorAct,
    error,
  } = useQuery({
    queryKey: ["act", actId],
    queryFn: () => getActById(actId!),
    enabled: !!actId,
    refetchInterval: (query) => {
      const status = query.state.data?.edo_status?.code;
      return shouldPoll && status !== "FINISHED" ? 5000 : false;
    },
  });

  if (isLoadingAct) {
    return (
      <div className={styles.wrapperLoader}>
        <Spin />
      </div>
    );
  }

  if (isErrorAct || !act || !actId) {
    return (
      <div className={styles.wrapper}>
        <Typography.Title level={3}>
          <Button
            type="link"
            size="large"
            icon={
              <ArrowLeftOutlined style={{ fontSize: "20px", marginRight: 8 }} />
            }
            onClick={() => navigate(ROUTES.MAIN)}
          ></Button>
          {t("sign_act.title")}
        </Typography.Title>
        <Empty
          description={
            <Typography.Text>
              {isErrorAct
                ? (error as any)?.response?.data?.message ||
                  t("sign_act.document_load_error")
                : t("sign_act.document_not_found")}
            </Typography.Text>
          }
        />
      </div>
    );
  }

  return (
    <>
      <Typography.Title level={3}>
        <Button
          type="link"
          size="large"
          icon={
            <ArrowLeftOutlined style={{ fontSize: "20px", marginRight: 8 }} />
          }
          onClick={() => navigate(ROUTES.MAIN)}
        ></Button>
        {t("sign_act.title")}
        <br />
      </Typography.Title>

      {act.can_payout && (
        <div style={{ marginBottom: 16 }}>
          <Typography.Title level={5}>Доступна выплата</Typography.Title>
          <ReceivePaymentButton actId={actId} block />
        </div>
      )}

      <ViewDocument
        documentId={actId}
        localeKey={"sign_act"}
        getDocumentPdfById={getActPdfById}
        downloadDocumentById={downloadActById}
      />
      <SingDocument
        document={act}
        localeKey={"sign_act"}
        setShouldPoll={setShouldPoll}
        signDocumentById={signActById}
        checkSignDocumentById={checkSignActById}
      />
    </>
  );
};
